import React from 'react';
import theme from '../../theme';

const Avatar = ({ 
  src, 
  alt = 'Avatar', 
  size = 'md',
  status = null, // 'online', 'offline', 'busy'
  badge = null,
  className = '',
  style = {},
  ...props 
}) => {
  const sizes = {
    xs: '32px',
    sm: '40px',
    md: '48px',
    lg: '64px',
    xl: '80px',
    '2xl': '96px',
  };
  
  const statusColors = {
    online: theme.colors.success,
    offline: theme.colors.neutral[500],
    busy: theme.colors.warning,
  };
  
  const avatarStyles = {
    width: sizes[size],
    height: sizes[size],
    borderRadius: theme.borderRadius.full,
    overflow: 'hidden',
    position: 'relative',
    display: 'inline-block',
    backgroundColor: theme.colors.bg.card,
    border: `2px solid ${theme.colors.border.default}`,
    ...style,
  };
  
  const imgStyles = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };
  
  const statusStyles = {
    position: 'absolute',
    bottom: '0',
    right: '0',
    width: '25%',
    height: '25%',
    backgroundColor: statusColors[status],
    borderRadius: theme.borderRadius.full,
    border: `2px solid ${theme.colors.bg.primary}`,
  };
  
  const badgeStyles = {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    backgroundColor: theme.colors.primary[500],
    color: theme.colors.text.primary,
    borderRadius: theme.borderRadius.full,
    padding: `${theme.spacing[1]} ${theme.spacing[2]}`,
    fontSize: theme.typography.fontSize.xs,
    fontWeight: theme.typography.fontWeight.bold,
    border: `2px solid ${theme.colors.bg.primary}`,
  };

  return (
    <div
      className={`castle-avatar castle-avatar-${size} ${className}`}
      style={avatarStyles}
      {...props}
    >
      {src ? (
        <img src={src} alt={alt} style={imgStyles} />
      ) : (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.primary[500],
          color: theme.colors.text.primary,
          fontSize: sizes[size].replace('px', '') / 2.5 + 'px',
          fontWeight: theme.typography.fontWeight.semibold,
        }}>
          {alt.charAt(0).toUpperCase()}
        </div>
      )}
      {status && <div style={statusStyles} />}
      {badge && <div style={badgeStyles}>{badge}</div>}
    </div>
  );
};

export default Avatar;